import {
  apiUrlWithParams,
  authBinaryFetch,
  authFetch,
  convertToJson,
  createForm,
  DataStorage,
  jsonFetch,
  removeEmptyFields,
} from "utils";

export const askAssetQuestion = (assetID, topic, question) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}/contact_point_person`, {
    method: "POST",
    json: { topic, question },
  });

export const getAsset = (assetID) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}`, {
    method: "GET",
  });

export const createAsset = (asset) =>
  authBinaryFetch(`${apiUrl}${version}/assets`, {
    method: "POST",
    body: createForm({ asset: removeEmptyFields(asset) }),
  }).then((res) => convertToJson(res));

export const deleteAsset = (assetID, status) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}?status=${status}`, {
    method: "DELETE",
  });

export const update = (asset) =>
  authFetch(`${apiUrl}${version}/assets/${asset.id}`, {
    method: "PATCH",
    json: { asset },
  });

export const getAssetNames = () =>
  authFetch(`${apiUrl}${version}/asset_names`, {
    method: "GET",
  });

export const getFilteredAssets = (parameters, page = 1) => {
  const url = apiUrlWithParams(`${apiUrl}${version}/assets`, {
    ...parameters,
    ...(!DataStorage.isPuppeteer() && { page: page - 1 }),
  });

  return authFetch(url, {
    method: "GET",
  });
};

export const exportPortfolioXls = (portfolioID) =>
  authBinaryFetch(`${apiUrl}${version}/assets/export?portfolio_id=${portfolioID}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

export const exportAssetsXls = (portfolioID, parameters) => {
  const url = apiUrlWithParams(`${apiUrl}${version}/assets/export`, {
    portfolioId: portfolioID,
    ...parameters,
  });

  return authBinaryFetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const exportPortfolioAssetsPdf = (url, userName, portfolioName) =>
  jsonFetch(
    `${lambdaExportEndpoint}/asset-export?url=${url}&locale=${DataStorage.getUserLocale()}&user_name=${userName}&portfolio_name=${portfolioName}`,
    {
      headers: {
        "X-User-Token": DataStorage.getUserToken(),
        "X-User-Email": DataStorage.getUserEmail(),
      },
    }
  );

export const exportAssetsPdf = (url, userName) =>
  jsonFetch(
    `${lambdaExportEndpoint}/feed-export?url=${url}&locale=${DataStorage.getUserLocale()}&user_name=${userName}`,
    {
      headers: {
        "X-User-Token": DataStorage.getUserToken(),
        "X-User-Email": DataStorage.getUserEmail(),
      },
    }
  );

export const requestAssetFlyer = (assetID) =>
  authFetch(`${apiUrl}${version}/requests/flyer?asset_id=${assetID}`, {
    method: "GET",
  });

export const subscribeAsset = (assetID) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}/subscribe`, {
    method: "POST",
  });

export const unsubscribeAsset = (assetID) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}/unsubscribe`, {
    method: "DELETE",
  });
